<script>
import { EventPresenceElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-presence-element-mixin";
import TextElement from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import ShowWhenNotLive from "%/dynamic-component-editor/options/show-when-not-live";
import { isEventLive } from "%/dynamic-component-editor/helpers/event-join-card";

const LIVE_LABEL = "LIVE";
const NOT_LIVE_LABEL = "NOT LIVE";

export default {
  name: "EventLiveBadge",
  elementPanelSettings: {
    displayIcon: "flag",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Live Badge",
  },
  extends: TextElement,
  mixins: [EventPresenceElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  options: [ShowWhenNotLive],
  computed: {
    isEditable() {
      return false;
    },
    isLive() {
      return isEventLive({
        entity: this.entity,
        now: this.countdownNow,
        isLivestream: this.isLivestreamEvent,
        presence: this.eventPresence,
      });
    },
    showsWhenNotLive() {
      return Boolean(this.getOptionValue(ShowWhenNotLive));
    },
    shouldShowText() {
      return this.isLive || this.showsWhenNotLive || this.editMode;
    },
    value() {
      return this.isLive ? LIVE_LABEL : NOT_LIVE_LABEL;
    },
  },
};
</script>
